module.exports = __webpack_public_path__ + "static/img/client6.8ce6c02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client6.png
// module id = sc+9
// module chunks = 1